<template lang="pug">
  v-icon {{ rateIcon }}
</template>

<script>
export default {
  props: ['rating'],
  computed: {
    rateIcon() {
      let icon = "hourglass_empty"
      switch(this.rating) {
        case "1":
        case "1.5":
        case "2":
          icon = "sentiment_very_dissatisfied"
          break;
        case "2.5":
        case "3":
        case "3.5":
        case "4":
          icon = "sentiment_satisfied"
          break;
        case "4.5":
        case "5":
          icon = "sentiment_very_satisfied"
          break;
        default:
          icon = "hourglass_empty"
      }
      return icon
    },
  }
}
</script>

<style scoped>
</style>